
const Footer = () => {
  return (
    <div className="fixed-bottom text-center bg-light p-3">
        {/* Metni projenin genel hizasına çekiyoruz */}
        <div className="container">
            Copyright © 2025 UmitDev
        </div>
    </div>
  )
}

export default Footer;